import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";

import { useStyles } from "./ViewAcademics.css";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import ClassAcademyForm from "../ClassAcademyForm/ClassAcademyForm";
import CustomTableHead from "../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import AddAcademics from "../AddAcademics/AddAcademics";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import AcademicsBody from "../AcademicsBody/AcademicsBody";
import CustomTableFooter from "../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewAcademics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 10,
      page: 0,
      column: [
        { name: "S.N." },
        { name: "Title" },
        { name: "Files" },
        { name: "Subject" },
        { name: "File Category" },
        { name: "Actions" },
      ],
      data: {
        class: "",
        faculty: "",
        group: "",
      },
      academics: [],
      subjects: [],
      detailStatus: false,
    };
  }

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  handleChange = (e) => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });
  };

  handleClassChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        class: e.target.value,
        faculty: "",
        group: "",
      },
    });
  };

  getAcademicFiles = async () => {
    try {
      const response = await Axios.get(`${url}/api/academics`, {
        params: {
          studentClass: this.state.data.class,
          faculty: this.state.data.faculty ? this.state.data.faculty : "",
          group: this.state.data.group ? this.state.data.group : "",
        },
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.academics.length !== 0) {
        this.setState({
          academics: response.data.academics,
        });
      } else {
        this.setState({
          academics: [],
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getAcademicFiles();
      }
    }
  };

  handleSubmit = async (e, subjects) => {
    e.preventDefault();
    try {
      if (subjects.length !== 0) {
        this.getAcademicFiles();
        this.setState({
          detailStatus: true,
          subjects,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleSubmit(e);
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle
            title="Manage Syllabus, Model Questions and Notes"
            refreshUrl={this.props.match.url}
          />
          <ClassAcademyForm
            data={this.state.data}
            handleClassChange={this.handleClassChange}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
            buttonLabel="Set Files"
          />
          {this.state.detailStatus && (
            <TableContainer>
              <Table>
                <CustomTableHead column={this.state.column} />

                <TableBody>
                  <AddAcademics
                    config={this.state.data}
                    subjects={this.state.subjects}
                    getAcademicFiles={this.getAcademicFiles}
                  />
                  {this.state.academics.length !== 0 &&
                    this.state.academics.map((academic, index) => (
                      <AcademicsBody
                        data={academic}
                        key={index}
                        index={index}
                        getAcademicFiles={this.getAcademicFiles}
                      />
                    ))}
                </TableBody>

                <CustomTableFooter
                  count={this.state.academics.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={this.handlePage}
                  onChangeRowsPerPage={this.handleRowsPerPage}
                />
              </Table>
            </TableContainer>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewAcademics)));
